import { useCallback } from 'react';
import { ContractRole } from './contracts.types';
import { useContracts } from './useContracts';

export const useGetContractRole = () => {
  const { contracts } = useContracts();

  return useCallback(
    (contractRoleId: string) => {
      let role: ContractRole | undefined = undefined;

      contracts.some(c => {
        const roleLookup = c.roles?.find(r => r.id === contractRoleId);
        if (roleLookup) {
          role = roleLookup;
          return true;
        }
        return false;
      });

      return role as ContractRole | undefined;
    },
    [contracts]
  );
};
